import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import ErrorStore, {ErrorStates} from "../../stores/ErrorStore";
import ErrorView from "../views/ErrorView";


class AppOrErrorWrapper extends React.Component {

    static propTypes = {
        children: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            "errorState": ErrorStore.getState()
        };
    }

    componentDidMount() {
        this.errorStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ERROR_STORE_UPDATED, this.handleStoreUpdate);
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.errorStoreSubscriber);
    }

    handleStoreUpdate = (msg, data) => {
        this.setState({
            "errorState": ErrorStore.getState()
        });
    };

    render() {
        if (this.state.errorState.errorState === ErrorStates.ERROR) {
            return (
                <ErrorView errorMessage={this.state.errorState.errorMessage} />
            );
        }

        return (
            <div>
                {this.props.children}
            </div>
        );
    }

}

export default withRouter(AppOrErrorWrapper);